export default "__VITE_ASSET__Db_LA45D__"